import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  questioninput: {
    width: '100%',
    margin: '25px'
    // height : '150px'
  },
  optioninput: {
    width: '90%',
    margin: '25px'
  }
});
